import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Button } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';

/**
 * Button component that handles editing stop details
 * Single responsibility: Provide the UI and logic for editing a stop
 */
const EditStopButton = ({ stopDetail, className, dataTestId }) => {
  const dispatch = useDispatch();

  const handleEditClick = () => {
    if (!stopDetail?.route?.id || !stopDetail?.id) {
      return;
    }
    
    dispatch(
      push(`/Route/${stopDetail.route.id}/Stop/edit/${stopDetail.id}`)
    );
  };

  return (
    <Button
      dataTestId={dataTestId || "edit-modal-button"}
      variant="secondary"
      type="button"
      className={className}
      onClick={handleEditClick}
    >
      {getResourceTo('grid.edit')}
    </Button>
  );
};

EditStopButton.propTypes = {
  stopDetail: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    route: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
  }).isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};

EditStopButton.defaultProps = {
  className: '',
  dataTestId: 'edit-modal-button'
};

export default EditStopButton;
